// Single source of truth for the six languages the site supports.
// Used by the booking flow so the active interface language travels with the
// order (checkout -> booking row -> Stripe metadata -> voucher email).
export const BOOKING_LANGS = ["es", "en", "fr", "it", "de", "pt"] as const;
export type BookingLang = (typeof BOOKING_LANGS)[number];

/** Normalize anything ("EN-US", "pt_BR", null) to one of the six codes. */
export function normalizeLang(value: unknown): BookingLang {
  const raw = String(value ?? "").trim().toLowerCase().slice(0, 2);
  return (BOOKING_LANGS as readonly string[]).includes(raw) ? (raw as BookingLang) : "es";
}
